import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { faEnvelope, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';

export interface EmailConfirmationData {
  countDaInviareValid: number;
  countDaInviareInvalid: number;
  countDaNonInviare: number;
}

@Component({
  selector: 'app-email-confirmation-dialog',
  templateUrl: './email-confirmation-dialog.component.html',
  styleUrls: ['./email-confirmation-dialog.component.scss'],
})
export class EmailConfirmationDialogComponent {
  // [ai-generated-code]
  faEnvelope = faEnvelope;
  faWarning = faTriangleExclamation;

  constructor(
    public dialogRef: MatDialogRef<EmailConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EmailConfirmationData,
  ) {}

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
